export const isFree = pricing => pricing?.categories?.includes('free') && !pricing?.categories?.includes('subscription')

export const hasPricingInfo = pricing => !!pricing?.amount || isFree(pricing)

export const hasCurrency = pricing => !!pricing?.currency

export const hasPeriodicity = pricing => !!pricing?.periodicity

export const hasOneTimePayment = pricing => pricing?.categories?.includes('one-time-license')

export const hasPricingModel = pricing => !!pricing?.pricing_model

export const hasPerUser = pricing => pricing?.pricing_model === 'Per User'

export const pricingModelIcons = {
  'Flat Rate': ['fal', 'user-circle'],
  'Per Feature': ['far', 'shapes'],
  'Usage Based': ['far', 'signal'],
  Other: ['far', 'signal'],
}

export const currencyIcons = {
  USD: ['far', 'dollar-sign'],
  CAD: ['far', 'dollar-sign'],
  AUD: ['far', 'dollar-sign'],
  EUR: ['far', 'euro-sign'],
  GBP: ['far', 'sterling-sign'],
  YEN: ['far', 'yen-sign'],
  JPY: ['far', 'yen-sign'],
}

/**
 * @param {import("@types/pricing").default} pricing
 **/
export const getCurrencyIcon = pricing => {
  const defaultCurrency = {
    hasSupportedIcon: true,
    currencyIcon: currencyIcons.USD,
  }

  if (hasCurrency(pricing)) {
    const { currency, currency_symbol } = pricing

    if (currencyIcons[currency]) {
      return { hasSupportedIcon: true, currencyIcon: currencyIcons[currency] }
    } else {
      return { hasSupportedIcon: false, currencyIcon: currency_symbol }
    }
  }
  return defaultCurrency
}
